module.exports = __webpack_public_path__ + "img/img9.9c4a3b83.png";